'use strict';

function SalaryIntroController(salaryService) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.hasRole = hasRole;

  function $onInit() {
    vm.url = vm.data.completed ? salaryService.urls.questionnaire.base({ token: vm.data.token}) : salaryService.urls.questionnaire.step({ token: vm.data.token, step: 1 });
  }

  function hasRole(role) {
    return vm.me.groups
      .map(function(group) { return group.name; })
      .some(function (groupName) { return groupName === role; });
  }
}

module.exports = SalaryIntroController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/salary/salary-intro/salary-intro.controller.js
 ** module id = 211
 ** module chunks = 0
 **/